import { render, staticRenderFns } from "./Lifemap.vue?vue&type=template&id=09cb52f4&"
import script from "./Lifemap.vue?vue&type=script&lang=js&"
export * from "./Lifemap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports